/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSettingFromJSON, StreemApiSettingToJSON, } from './';
export function StreemApiBatchCreateCompanyRequestFromJSON(json) {
    return StreemApiBatchCreateCompanyRequestFromJSONTyped(json, false);
}
export function StreemApiBatchCreateCompanyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'csvData': !exists(json, 'csv_data') ? undefined : json['csv_data'],
        'settings': !exists(json, 'settings') ? undefined : (json['settings'].map(StreemApiSettingFromJSON)),
    };
}
export function StreemApiBatchCreateCompanyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'csv_data': value.csvData,
        'settings': value.settings === undefined ? undefined : (value.settings.map(StreemApiSettingToJSON)),
    };
}
//# sourceMappingURL=StreemApiBatchCreateCompanyRequest.js.map